// extracted by mini-css-extract-plugin
export default {"container":"HomeItemList_container__QVUiL"};